import React from "react";
import '../assets/css/styles.css';
import '../assets/css/colors.css';
import '../assets/css/plugins/font-awesome.css';
import '../assets/css/plugins/flaticon.css';
import '../assets/css/plugins/bootstrap.min.css';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
} from 'mdb-react-ui-kit';

import img1 from "../assets/images/Sports and Games/1.jpg";
import img2 from "../assets/images/Sports and Games/2.jpg";
import img3 from "../assets/images/Sports and Games/3.jpg";
import img4 from "../assets/images/Sports and Games/4.jpg";
import img5 from "../assets/images/Sports and Games/5.jpg";
import img6 from "../assets/images/Sports and Games/6.jpg";
export const Sports = () => {
  return (
    // <div>
    //   <section className="page-title" style={{ padding: "0px" }}>
    //     <div className="container">
    //       <div className="row">
    //         <div className="col-lg-12 col-md-12">

    //           <div className="breadcrumbs-wrap">
    //             <h1 style={{ textAlign: "center", fontSize: "25px", color: "#222a35" }}>Sports & Games</h1>



    //           </div>

    //         </div>
    //       </div>
    //     </div>
    //   </section>
    //   <section className="gray">

    //     <div className="container">

    //       <div className="row">

    //         <div className="col-lg-12 col-md-12 col-sm-12 col-12">
    //           <div className="article_detail_wrapss single_article_wrap format-standard">
    //             <div className="article_body_wrap">

    //               <div className="article_featured_image">
    //                 <img className="img-fluid" src="https://malayaleeclub.org/assets/img/sports.jpg" alt="" />
    //               </div>


    //               <h1>Coming Soon</h1>


    //             </div>
    //           </div>




    //         </div>



    //       </div>

    //     </div>

    //   </section>
    // </div>
    <MDBRow>
      <MDBCol lg={4} md={12} className='mb-4 mb-lg-0'>
        
        <img
          src={img1}
          className='w-100 shadow-1-strong rounded mb-4'
          alt='sports&games'
        />

        <img
          src={img4}
          className='w-100 shadow-1-strong rounded mb-4'
          alt='Wintry Mountain Landscape'
        />
      </MDBCol>

      <MDBCol lg={4} className='mb-4 mb-lg-0'>
        <img
          src={img2}
          className='w-100 shadow-1-strong rounded mb-4'
          alt='Mountains in the Clouds'
        />

        <img
          src={img5}
          className='w-100 shadow-1-strong rounded mb-4'
          alt='Boat on Calm Water'
        />
      </MDBCol>

      <MDBCol lg={4} className='mb-4 mb-lg-0'>
        <img
          src={img3}
          className='w-100 shadow-1-strong rounded mb-4'
          alt='Waves at Sea'
        />

        <img
          src={img6}
          className='w-100 shadow-1-strong rounded mb-4'
          alt='Yosemite National Park'
        />
      </MDBCol>
    </MDBRow>
  );
};
